import React, { Component } from "react";
import { connect } from "react-redux";
import { AddDeviceGroupDialog } from "../dialogs/AddDeviceGroupDialog";
import { mapKV, asArray, asSimpleArray } from "../utils/map";
import { addNewDeviceGroup } from "../redux/actions/deviceGroupActions";
import { extractAppsApprovedByBundles, extractAllApps, extractKioskAppOptions } from "../utils/deviceGroupUtils";

const NONE = "NONE";

export class AddDeviceGroup extends Component {
  state = {
    name: "",
    registrationCode: "",
    nameNotUnique: false,
    registrationCodeNotUnique: false,
    saveAvaliable: false,
    selectedBundleKeys: [],
    selectedBundleKeys: [],
    kioskAppKey: NONE,
    organizationKey: "",
    selectedApps: {}
  };

  componentDidMount() {
    const { currentUser } = this.props;
    const organizationKey = currentUser.organizationRef.id;
    this.setState({ organizationKey });
  }

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onRegistrationCodeChange = registrationCode =>
    this.setState({ registrationCode }, this.checkSaveAvaliable);

  onBundlesChange = selectedBundleKeys =>
    this.setState({ selectedBundleKeys }, this.checkSaveAvaliable);

  onKioskAppChange = kioskAppKey => this.setState({ kioskAppKey });

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  checkSaveAvaliable = () => {
    const {
      name,
      registrationCode,
      organizationKey
    } = this.state;
    const { deviceGroups, selectedGroupKey } = this.props;
    let nameNotUnique = false;
    let registrationCodeNotUnique = false;
    mapKV(deviceGroups, (k, v) => {
      if (k === selectedGroupKey) return;
      if (name.trim() === v.name) nameNotUnique = true;
      if (registrationCode === v.registrationCode)
        registrationCodeNotUnique = true;
    });

    this.setState({ nameNotUnique, registrationCodeNotUnique });

    let saveAvaliable = true;
    if (
      nameNotUnique ||
      name === "" ||
      registrationCodeNotUnique ||
      registrationCode === "" ||
      organizationKey === ""
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onSave = () => {
    const {
      name,
      registrationCode,
      selectedBundleKeys,
      kioskAppKey,
      organizationKey,
      selectedApps
    } = this.state;
    const { addNewDeviceGroup, onClose } = this.props;

    const approvedAppsKeys = [];
    asArray(selectedApps).map(({key}) => approvedAppsKeys.push(key));

    addNewDeviceGroup({
      name,
      registrationCode,
      selectedBundleKeys,
      kioskAppKey,
      organizationKey,
      approvedAppsKeys
    });
    onClose();
  };  

  onAppSelect = ({ key, value }) => {
    let { selectedApps } = this.state;
    if(value){
        selectedApps[key] = value;
    }else{
        delete selectedApps[key];
    }
    this.setState({ selectedApps });
  };

  render() {
    const { onClose, contentBundles, apps } = this.props;
    const {
      selectedBundleKeys,
      name,
      registrationCode,
      nameNotUnique,
      registrationCodeNotUnique,
      saveAvaliable,
      kioskAppKey,
      organizationKey,
      selectedApps
    } = this.state;

    let allAppBundles = [];
    mapKV(contentBundles, (key, { name }) =>
      allAppBundles.push({ value: key, label: name })
    );
   
    const allApps = extractAllApps(apps);

    const appsApprovedByBundles = extractAppsApprovedByBundles({
        contentBundles,
        selectedBundleKeys,
      });

    const kioskAppOptions = extractKioskAppOptions({
      appsApprovedByBundles,
      apps,
      selectedApps
    });

    return (
      <AddDeviceGroupDialog
        onClose={onClose}
        onSave={this.onSave}
        allAppBundles={allAppBundles}
        selectedBundleKeys={selectedBundleKeys}
        onBundleSelect={this.onBundlesChange}
        name={name}
        registrationCode={registrationCode}
        nameNotUnique={nameNotUnique}
        registrationCodeNotUnique={registrationCodeNotUnique}
        saveAvaliable={saveAvaliable}
        onNameChange={this.onNameChange}        
        onRegistrationCodeChange={this.onRegistrationCodeChange}
        kioskAppKey={kioskAppKey}
        kioskAppOptions={kioskAppOptions}
        onKioskAppChange={this.onKioskAppChange}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
        allApps={allApps}
        selectedApps={selectedApps}
        appsApprovedByBundles={appsApprovedByBundles}
        onAppSelect={this.onAppSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  contentBundles: state.data.contentBundles,
  apps: state.data.apps,
  deviceGroups: state.data.deviceGroups,
  currentUser: state.user.user
});

const mapDispatchToProps = { addNewDeviceGroup };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDeviceGroup);
